import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import AUX from "../../../hoc/Aux_";
import $ from "jquery";
import AuthService from "../../Auth/AuthService";
import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import TableCustomTotal from "../../Shared/TableCustomTotal";
import actionFilter from "../../../store/advancedfilter/action";
import MailGunConfigurationTabs from "../../Email/AuthorizedSenders/MailGunConfigurationTabs";
import mailGunEmailActions from "../../../store/mailgunEmails/action";
import MailGunEmailTypes from "../../Email/Enums/MailGunEmailTypes";
import MG_DeleteAllAuthSenders from "../../Email/ModalPopups/MG_DeleteAllAuthSenders";
import EmailConfigTabs from "../../Email/Enums/EmailConfigTabs";
import EmailListService from "../../Email/EmailListService";
import MG_DeleteEmailList from "../../Email/ModalPopups/MG_DeleteEmailList";
import * as Permissions from "../../Permissions/PermissionValues";
import { Spinner } from "reactstrap";
import _ from "lodash";
import PermissionFeature from "../../Permissions/PermissionFeature";

/// Configure Email Modal Opened from (Saved Search)
//##SSEmail Modal
class SavedSearchEmailList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_list_title: "",
      showDeleteEmailListModal: false,
      showModal: this.props.showModal,
      memberId: AuthService.getProfile().memberData.id,
      SortOrder: "seniorityasc",
      columns: [
        {
          text: "First Name",
          dataField: "firstName",
          sort: true,
        },
        {
          text: "Last Name",
          dataField: "lastName",
          sort: true,
        },
        {
          text: "Facility",
          dataField: "facility",
          sort: true,
        },
      ],
      data: [],
      recordsPerPage: this.props.recordsPerPage
        ? this.props.recordsPerPage
        : 10,
      currentPage: 1,
      totalCount: 0,
      totalRecordsCount: 0,

      mailingListName: "",
      mailingListAddress: "",

      domain: "",
      //postDomain: "",
      emailListId: 0,
      emailEntityType: 0,
      entityKey: 0,
      email_Address: "",
      listPrivilige: "",
      selectedPrivilege: "",
      replyPreference: "",
      currentEmailConfigTab: "",
    };
    if (this.props.savedSearchId > 0) {
      this.setState({
        savedSearchId: this.props.savedSearchId,
      });
    }
    this.confirmEmailList = () => {
      this.confirmed = async () => {
        let deleteResponse = null;
        const { emailListId, emailEntityType } = this.props.melstate;
        if (emailEntityType == MailGunEmailTypes.Member) {
          await EmailListService.DeleteSSEmailList(emailListId).then(
            ({ data: response }) => {
              $(".loading").hide();
              if (response.status === "success") {
                toast.success("Email list removed successfully!");
                deleteResponse = 1;
                $(".loading").hide();
              } else {
                toast.error(response.message);
                deleteResponse = 0;
                $(".loading").hide();
              }
            }
          );
        } else if (emailEntityType !== MailGunEmailTypes.Member) {
          await EmailListService.DeleteFRTEmailList(emailListId).then(
            ({ data: response }) => {
              $(".loading").hide();
              if (response.status === "success") {
                toast.success("Email list removed successfully!");
                deleteResponse = 1;
                $(".loading").hide();
              } else {
                toast.error(response.message);
                deleteResponse = 0;
                $(".loading").hide();
              }
            }
          );
        }

        this.toggleDeleteEmailListModal();

        this.handleClose();
        if (deleteResponse == 1) {
          this.props.onDeleteEmailList();
          this.onModalExited();
        }
      };

      return this;
    };
    this.mailgunConfigurationTabComp = React.createRef();
  }
  toggleDeleteEmailListModal = () => {
    this.setState({
      showDeleteEmailListModal: !this.state.showDeleteEmailListModal,
    });
  };
    canView = () => {
        return AuthService.canView(PermissionFeature.TeamsTeams);
    };

    canAdd = () => {
        return AuthService.canAdd(PermissionFeature.TeamsTeams);
    };

    canUpdate = () => {
        return AuthService.canUpdate(PermissionFeature.TeamsTeams);
    };

  canCreateorUpdateEmailList = () => {
    ///Edit Mode
    if (this.state.emailListId > 0 || this.props.emailListId > 0) {
      return this.canUpdate();
    } else {
      return this.canAdd();
    }
  };
  componentDidMount() {}

  handleChange = (evt) => {
    this.setState({
      [evt.target.id]: evt.target.value,
    });
  };

  handleClose = () => {
    this.setState({
      showModal: false,
    });
    this.props.onClose();
  };

  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };

  resetState = () => {
    this.setState({
      emailListExists: false,
      mailingListAddress: "",
      emailListId: 0,
      mailingListName: "",
    });
  };
  onModalExited = () => {
    this.props.resetEmailConfigDetails();
    this.resetState();
    this.handleClose();
  };

  onShow = async () => {
    //this.refreshData();
    // this.getSubscribedMembers();
    // this.getUnsubscribeMembers();
    $(".loading").show();

    ///////// Work of Email Enhancements/////////
    await this.props.setAddtlSubsLoading(true);
    if (this.props.savedSearchId) {
      await EmailListService.GetEmailPriviliges()
        .then(async ({ data: response }) => {
          if (response.status === "success") {
            await this.setState({
              emailPriviliges: response,
            });
          }
        })
        .catch((ex) => {
          console.log(ex);
          toast.error("Something went wrong!");
        });
      await EmailListService.GetSavedSearchDetail(this.props.savedSearchId)
        .then(async ({ data: response }) => {
          if (response.status === "success") {
            await this.setState({
              entityKey: response.searchDetail.saved_search_id,
              mailingListAddress: response.searchDetail.email_address,
              email_list_title: response.searchDetail.email_list_title,
              emailListId: response.searchDetail.id, //Settings mailing list Id
              emailEntityType: MailGunEmailTypes.Member,
              replyPreference: response.searchDetail.reply_preference,
              listPrivilige: response.selectedPrivilege,
            });
            console.log(this.state.mailingListAddress);
          }
        })
        .catch((ex) => {
          console.log(ex);
          toast.error("Something went wrong!");
        });

      await EmailListService.GetDomainName()
        .then(async ({ data: response }) => {
          if (response.status === "success") {
            await this.setState({
              domain: response.domain,
              //postDomain: response.postDomain,
            });
            //console.log(this.state.domain);
            let domainName = response.domain;
            domainName = domainName.replace("@", "");
            await this.props.setMgListDomain(domainName);
            //await this.props.setMgPostListDomain(response.postDomain);
          }
        })
        .catch((ex) => {
          console.log(ex);
          toast.error("Something went wrong!");
        });
    }

    debugger;

    let {
      email_list_title,
      emailListId,
      entityKey,
      emailEntityType,
      mailingListAddress,
      replyPreference,
      listPrivilige,
    } = this.state;
    const configTab = this.mailgunConfigurationTabComp.current;

    //Edit Mode
    if (emailListId) {
      let formData = {
        emailListId: emailListId,
        emailEntityType: emailEntityType,
        entityKey: entityKey,
        mailingListAddress,
        replyPreference,
        listPrivilige,
      };
      await this.props.setMgListFullAddress(mailingListAddress);
      if (
        formData.emailListId &&
        formData.emailEntityType &&
        formData.entityKey &&
        formData.mailingListAddress
      ) {
        this.props.resetAuthSenderMembers();
        this.props.resetAddlMembers();

        this.props.getAuthSenders(formData);
        await this.props.setEmailListDetails(formData);

        let fullAliasPlusDomain = mailingListAddress;
        //  console.log("fullAliasPlusDomain", fullAliasPlusDomain);
        this.props.setMgListFullAddress(fullAliasPlusDomain);

        this.props.setEmailListName(email_list_title);
        await this.props.reloadAdditionalSubsribersTables();
        await this.props.setCurrentEmailConfigTab(EmailConfigTabs.Subscribers);
        await this.setState({
          currentEmailConfigTab: EmailConfigTabs.Subscribers,
        });
      }
    }
    /// Add mode
    else {
      this.props.resetEmailConfigDetails();
      let mailingListAddress = this.props.savedSearchTitle
        .replace(/\s+/g, "-")
        .toLowerCase();
      //The regular expression /\s+/g is used to match one or more whitespace characters.
      //The g flag at the end of the regular expression is used to perform a global search,
      //which means it will replace all occurrences of the matched pattern in the string
      let fullAliasPlusDomain = mailingListAddress + this.state.domain;
      //console.log("fullAliasPlusDomain", fullAliasPlusDomain);
      await this.props.setMgListFullAddress(fullAliasPlusDomain);
      if (this.props.savedSearchTitle) {
        let mailingListName = mailingListAddress.replace(/[^\w\s-]/gi, "");
        await this.props.setEmailListName(mailingListName);
        await this.setState({
          mailingListAddress: fullAliasPlusDomain,
        });
      }
    }
    await this.props.setAddtlSubsLoading(false);
    if (emailListId == 0) {
      await this.props.setCurrentEmailConfigTab(EmailConfigTabs.Settings);
      await this.setState({
        currentEmailConfigTab: EmailConfigTabs.Settings,
      });
    }
    debugger;
    let { currentEmailConfigTab } = this.state;
    configTab && (await configTab.setKey(currentEmailConfigTab));
    $(".loading").hide();

    ////////////////////////////////////////////
  };

  onSave = () => {
    debugger;
    this.showSpinner();

    let emailDetails = "/api/SavedSearch/SaveEmailListDetails";
    let {
      isAliasChanged,
      mgListAddress: emailAddress,
      mailingListName: email_list_title,
      replyPreference: reply_preference,
      mgListAddressAlias,
      selectedPrivilige,
      authorizedSendersMembers,
      authorizedSendersTeams,
      additionalRecipientsMembers,
      additionalRecipientsTeams,
      additionalRecipientsNonNatca,
    } = this.props.melstate;

    let emailListAdditionalRecpts = [
      ...additionalRecipientsMembers,
      ...additionalRecipientsTeams,
      ...additionalRecipientsNonNatca,
    ];

    let emailAuthorizedSenders = [
      ...authorizedSendersMembers,
      ...authorizedSendersTeams,
    ];

    let emailListbody = {
      domain_id: 1,
      //email_address: emailAddress + Constants.DEFAULT_DOMAIN,
      // email_address: emailAddress + this.state.domain,
      saved_search_id: this.props.savedSearchId,
      search_email_privilege_id:
        selectedPrivilige === "readonly"
          ? 1
          : selectedPrivilige === "members"
          ? 2
          : 3,
      email_address: isAliasChanged
        ? `${mgListAddressAlias}${this.state.domain}`
        : emailAddress,

      //email_list_title: emailListTitle,
      //reply_preference: this.state.reply_preference,

      email_list_title: email_list_title,
      reply_preference: reply_preference,

      email_alias: mgListAddressAlias,

      selectedPrivilige: selectedPrivilige,
      isAliasChanged,
      emailAuthorizedSenders: emailAuthorizedSenders || [],
      additionalRecipientsTeams: additionalRecipientsTeams || [], // Work for maintaing all Additional Team Recipients
    };

    axios.post(emailDetails, emailListbody).then(({ data: res }) => {
      if (res.status.toLowerCase() === "success") {
        //// Creating and Adding Members to MailGun
        const emailListId = res.emailListId;
        const entityKey = res.saved_search_id;
        const responseMessage = res.message;
        const url = "/api/MailGun/AddMembersToList";
        const _data = this.state.savedSearchId;
        const body = {
          searchId: this.props.savedSearchId,
          J_membersaddress: 0,
          address: isAliasChanged
            ? `${mgListAddressAlias}${this.state.domain}`
            : emailAddress,
          memberName: 0,
          Description: "",
          name: email_list_title,
          //###(request.AddParameter("list", model.ListName, ParameterType.UrlSegment)####
          ListName: isAliasChanged
            ? `${mgListAddressAlias}${this.state.domain}`
            : emailAddress, // mgListAddressAlias + this.state.domain,
          access_level: selectedPrivilige,

          totalrecords: 0,
          emailListId: emailListId, //this.props.emailListId,
          reply_preference: reply_preference,
          emailListAdditionalRecpts: emailListAdditionalRecpts || [],
        };
        axios.post(url, body).then(({ data: res }) => {
          if (res.status.toLowerCase() === "success") {
            this.hideSpinner();

            if (responseMessage == "Email list saved successfully.") {
              toast.success(
                "Mailing list being created, please check back in a few minutes."
              );
            } else {
              toast.success(res.message);
            }
            this.props.onSave(emailListId, entityKey);
            this.hideSpinner();
            //this.handleClose();
            this.onModalExited();
          } else {
            toast.error(res.message);
            this.hideSpinner();
          }
        });
      } else {
        toast.error(res.message);
        this.hideSpinner();
      }
    });
  };

  render() {
    return (
      <AUX>
        <Modal
          className="saved-search-email-list locationMemberSavedSearchesCEL"
          show={this.props.showModal}
          onHide={this.onModalExited}
          size="lg"
          dialogClassName="modal-55w"
          backdrop="static"
          centered
          scrollable
          onShow={this.onShow}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5 className="modal-title mt-0">
                {this.state.emailListId > 0 || this.props.emailListId > 0
                  ? "Update Email List"
                  : "Create Email List"}
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
          // style={{
          //   "max-height": "calc(100vh - 210px)",
          //   "overflow-y": "auto",
          // }}
          >
            {!_.isEmpty(this.state.mailingListAddress) && (
              <MailGunConfigurationTabs
                emailEntityType={MailGunEmailTypes.Member}
                emailListId={this.state.emailListId}
                mgListAddress={this.state.mailingListAddress}
                ssUpdateEmailListMode={this.props.emailListId !== 0}
                isModalPopUpOpended={true}
                currentEmailConfigTab={this.state.currentEmailConfigTab}
                ref={this.mailgunConfigurationTabComp}
                entityKey={this.state.entityKey}
                hideActionIcons={EmailListService.shouldHideActionIcons()}
                emailListExists={this.props.emailListId !== 0}
              />
            )}
            {_.isEmpty(this.state.mailingListAddress) && (
              <div className="d-flex justify-content-center p-4">
                <Spinner />
              </div>
            )}
            {<br />}
            <button
              className="btn btn-primary w-md waves-effect cancelModal waves-light mr-2 mc"
              data-dismiss="modal"
              aria-hidden="true"
              onClick={this.onModalExited}
            >
              Cancel
            </button>
            {EmailListService.shouldHideActionIcons() ? (
              <button
                className="btn btn-success w-md mc"
                onClick={() => this.onSave()}
              >
                {this.props.emailListId === 0 ? "Save" : "Update"}
              </button>
            ) : (
              ///************Invisible Btn******/
              <button className="btn btn-success w-md mc invisible">
                {this.props.emailListId === 0 ? "Save" : "Update"}
              </button>
            )}

            {this.props.emailListId !== 0 &&
              EmailListService.canDeleteEmailList() === true && (
                <button
                  className="btn btn-danger w-md waves-effect waves-light ml-2 mc"
                  type="button"
                  onClick={this.toggleDeleteEmailListModal}
                >
                  {/* ///Save Search Email Enhancement Work */}
                  Delete Email List
                </button>
              )}
          </Modal.Body>
        </Modal>
        <MG_DeleteEmailList
          modal={this.state.showDeleteEmailListModal}
          confirm={this.confirmEmailList}
          toggle={this.toggleDeleteEmailListModal}
        />
      </AUX>
    );
  }
}

export default connect(
  (state) => ({
    filterState: state.advancedFilter,
    melstate: state.mailGunEmail,
  }),
  {
    ...actionFilter,
    ...mailGunEmailActions,
  }
)(SavedSearchEmailList);
